import {
  Column, ColumnLayout, FieldSet, ModalBody, Typography,
} from '@visionplanner/ui-react-material';
import styled from 'styled-components';
import { defaultYears } from '../../../common/utils/date';

const StyledModalBody = styled(ModalBody)`
  .number-field [class^="currency-input__CurrencyInputWrapper"] {
    margin-left: 35%;
  }

  .start-date {
    & .SingleDatePicker, & .SingleDatePickerInput {
      width: 100%;
    }
  }

  .align-date {
    & .SingleDatePicker .SingleDatePickerInput {
      margin-left: -27%;
    }
  }
`;

const ColumnLayoutWrapper = styled(ColumnLayout)`
&.mdc-layout-grid {
  padding: ${({ theme }) => theme.paddings.zero};
  margin-top: ${({ theme }) => theme.margins.medium};
}
`;

const StyledColumn = styled(Column)`
  margin: auto 0;
  font-size: ${({ theme }) => theme.fontSizes.fs14};
  line-height: 1.063rem;
  width: fit-content;
`;

const CurrencyField = ({
  label,
  dataTa,
  name,
  disabled,
  className,
  prefix,
}) => (
  <FieldSet
    label={label}
    dataTa={dataTa}
    type="currency"
    decimalScale={2}
    name={name}
    prefix={prefix || ''}
    className={className || 'number-field'}
    disabled={disabled}
  />
);

export const InvoicingForm = ({ values, invoiceTypes }) => (
  <StyledModalBody className="pos-rel">
    <Typography use="h6">Facturatie</Typography>
    <ColumnLayoutWrapper>
      <InvoiceStartDateSection />
      <TypeOfInvoiceSection invoiceTypes={invoiceTypes} values={values} />
      <OnboardingFeeSection />
      <MinimumFeeSection values={values} />
      <InvoiceReductionSection />
    </ColumnLayoutWrapper>
  </StyledModalBody>
);

const InvoiceStartDateSection = () => (
  <Column span={12}>
    <FieldSet
      type="date"
      label="Factuur vanaf"
      name="invoiceStartDate"
      required
      className="start-date"
      dataTa="invoice-start-date"
      isDateReadOnly
      showSelectOptions
      years={defaultYears()}
    />
  </Column>
);

const TypeOfInvoiceSection = ({ invoiceTypes }) => (
  <Column span={12}>
    <FieldSet
      type="selectOne"
      controlType="autocomplete"
      label="Type factuur"
      name="typeOfInvoice"
      options={invoiceTypes}
      placeholder="Selecteer"
      required
      dataTa="type-of-invoice"
      noOptionsMessage="Geen opties"
      className="type-of-invoice"
    />
  </Column>
);

const OnboardingFeeSection = () => (
  <>
    <Column span={8}>
      <CurrencyField
        width="10%"
        dataTa="onboarding-fee"
        label="Onboardings fee per maand"
        name="onboardingFeePerMonth"
      />
    </Column>
    <Column span={4}>
      <FieldSet
        type="date"
        label="t/m"
        name="onboardingEndDate"
        dataTa="onboarding-date"
        isDateReadOnly
        showSelectOptions
        years={defaultYears()}
        className="align-date"
        withPortal
      />
    </Column>
  </>
);

const MinimumFeeSection = ({ values }) => (
  <>
    <StyledColumn span={5}>
      Minimum factuur bedrag
    </StyledColumn>
    <StyledColumn span={2}>
      <FieldSet
        type="boolean"
        controlType="switch"
        name="isMinimumFee"
        dataTa="minimum-fee-switch"
      />
    </StyledColumn>
    {!values.isMinimumFee
      ? (
        <Column span={5}>
          <CurrencyField
            label="handmatig"
            dataTa="fixed-fee"
            className="fixed-fee"
            name="customAmountPerMonth"
          />
        </Column>
      ) : (
        <Column span={5}>
          <CurrencyField
            label="standaard"
            dataTa="minimum-fee"
            name="minimumFee"
            className="fixed-fee"
            disabled
          />
        </Column>
      )}
  </>
);

const InvoiceReductionSection = () => (
  <>
    <Column span={8}>
      <CurrencyField
        label="Factuurkorting"
        dataTa="reduction-percentage"
        name="reductionPercentage"
        prefix="%"
      />
    </Column>
    <Column span={4}>
      <FieldSet
        label="t/m"
        dataTa="reduction-end-date"
        isDateReadOnly
        name="reductionEndDate"
        withPortal
        showSelectOptions
        type="date"
        years={defaultYears()}
        className="align-date"
      />
    </Column>
  </>
);
